import React, { useEffect, useState } from 'react';
import { motion } from 'framer-motion';
import { Check, ShieldCheck, Zap, Clock, Sparkles } from 'lucide-react';
export function Pricing() {
  const [timeLeft, setTimeLeft] = useState({
    hours: 23,
    minutes: 59,
    seconds: 59
  });
  useEffect(() => {
    const endTimeKey = 'enfermeria_offer_end_time';
    const getEndTime = () => {
      const stored = localStorage.getItem(endTimeKey);
      if (stored) {
        const parsed = parseInt(stored, 10);
        if (!isNaN(parsed) && parsed > Date.now()) {
          return parsed;
        }
      }
      const newEndTime = Date.now() + 24 * 60 * 60 * 1000;
      localStorage.setItem(endTimeKey, newEndTime.toString());
      return newEndTime;
    };
    const tick = () => {
      const endTime = getEndTime();
      const distance = endTime - Date.now();
      const safeDistance = distance > 0 ? distance : 0;
      setTimeLeft({
        hours: Math.floor(safeDistance % (1000 * 60 * 60 * 24) / (1000 * 60 * 60)),
        minutes: Math.floor(safeDistance % (1000 * 60 * 60) / (1000 * 60)),
        seconds: Math.floor(safeDistance % (1000 * 60) / 1000)
      });
    };
    tick();
    const interval = setInterval(tick, 1000);
    return () => clearInterval(interval);
  }, []);
  const handlePurchase = () => {
    window.location.href = 'https://checkout.ebookpoint.shop/cart/59648155746385:1';
  };
  const includes = ['8 módulos completos de práctica real', 'Urgencias, procedimientos y farmacología aplicada', '10 planillas + infografías para el office', 'Bono 1: Planillas Excel con fórmulas automáticas', 'Bono 2: Apéndices Word editables', 'Acceso de por vida y actualizaciones'];
  return <section id="compra" className="py-20 bg-pastel-50 text-navy-900 px-4" data-id="element-160">
      <div className="max-w-md mx-auto" data-id="element-161">
        {/* Countdown */}
        <div className="text-center mb-8" data-id="element-162">
          <div className="inline-flex items-center gap-2 bg-red-100 text-red-700 px-4 py-2 rounded-full font-medium mb-4 border border-red-200" data-id="element-163">
            <Clock size={18} data-id="element-164" />
            <span data-id="element-165">La oferta termina en:</span>
            <span className="font-mono font-bold tracking-wider" data-id="element-166">
              {String(timeLeft.hours).padStart(2, '0')}:
              {String(timeLeft.minutes).padStart(2, '0')}:
              {String(timeLeft.seconds).padStart(2, '0')}
            </span>
          </div>
          <h2 className="text-3xl md:text-4xl font-bold mb-2 text-navy-900" data-id="element-167">
            Llevate Enfermería Resuelta hoy
          </h2>
          <p className="text-navy-700" data-id="element-168">
            Acceso completo + 2 bonos descargables, por tiempo limitado.
          </p>
        </div>

        {/* Single Offer Card */}
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="rounded-2xl p-6 md:p-8 border-2 border-gold-500 bg-white shadow-lg mb-6" data-id="element-169">
          <div className="text-center mb-6" data-id="element-170">
            <h3 className="text-xl font-bold text-navy-900 mb-2" data-id="element-171">
              Enfermería Resuelta — Guía práctica para enfermeros/as
            </h3>
            <p className="text-slate-400 text-base line-through" data-id="element-172">$52.690</p>
            <div className="text-4xl font-extrabold text-gold-600" data-id="element-173">$19.899</div>
            <p className="text-xs text-navy-600 mt-1" data-id="element-174">
              Pago único · Sin suscripción
            </p>
          </div>

          <ul className="space-y-3" data-id="element-175">
            {includes.map((item, i) => <li key={i} className="flex items-start gap-2 text-sm text-navy-800" data-id="element-176">
                <Check size={16} className="text-gold-600 shrink-0 mt-0.5" data-id="element-177" />
                <span data-id="element-178">{item}</span>
              </li>)}
          </ul>

          {/* Bonus extra: versión de pasillo */}
          <div className="mt-5 flex items-start gap-2 rounded-xl bg-pastel-100 border border-pastel-200 p-3" data-id="element-179">
            <Sparkles size={18} className="text-gold-600 shrink-0 mt-0.5" data-id="element-180" />
            <p className="text-sm font-medium text-navy-800" data-id="element-181">
              Además llevate hoy la versión de pasillo, para tenerlo a mano y
              leer solo lo necesario.
            </p>
          </div>
        </motion.div>

        {/* CTA Button */}
        <div className="text-center" data-id="element-182">
          <button onClick={handlePurchase} className="w-full px-10 py-5 bg-navy-800 hover:bg-navy-700 text-white font-extrabold text-xl rounded-xl shadow-lg hover:shadow-xl transition-all transform hover:-translate-y-1 mb-6" data-id="element-183">
            Quiero ser mas eficiente en la guardia
          </button>

          {/* Trust Badges */}
          <div className="flex flex-wrap justify-center gap-6 text-sm text-navy-700" data-id="element-184">
            <div className="flex items-center gap-2" data-id="element-185">
              <ShieldCheck size={18} className="text-green-600" data-id="element-186" />
              <span data-id="element-187">Pago 100% Seguro</span>
            </div>
            <div className="flex items-center gap-2" data-id="element-188">
              <Zap size={18} className="text-gold-600" data-id="element-189" />
              <span data-id="element-190">Acceso Inmediato</span>
            </div>
          </div>
        </div>
      </div>
    </section>;
}